import { defineMessages } from 'react-intl';

import generalMessages from 'src/messages';

const messages = defineMessages({
  numerOfAliquots: {
    id: 'numberOfAliquots',
    defaultMessage: 'Number of aliquots',
  },
  aliquotVolume: {
    id: 'aliquotVolume',
    defaultMessage: 'Aliquot volume',
  },
  // Number of Aliquots
  emptyNormalizationAliquotsNumberError: {
    id: 'emptyNormalizationAliquotsNumberError',
    defaultMessage: 'Number of aliquots is required!',
  },
  numericalNormalizationALiqtuosNumberError: {
    id: 'numericalNormalizationALiqtuosNumberError',
    defaultMessage: 'Aliquots should contain only numbers!',
  },
  minNrNormalizationAliquotsError: {
    id: 'minNrNormalizationAliquotsError',
    defaultMessage: 'Minimum quantity for aliquots is 1.',
  },
  maxNrNormalizationAliquotsError: {
    id: 'maxNrNormalizationAliquotsError',
    defaultMessage: 'Maximum quantity for aliquots is 99.',
  },
  // Aliquot volume
  emptyNormalizationAliquotsVolumeInputError: {
    id: 'emptyNormalizationAliquotsVolumeInputError',
    defaultMessage: 'Aliquots volume is required!',
  },
  noNrNormalizationAliquotsVolumeError: {
    id: 'noNrNormalizationAliquotsVolumeError',
    defaultMessage: 'Aliquots volume should contain only numbers!',
  },
  minNrNormalizationAliquotsVolumeError: {
    id: 'minNrNormalizationAliquotsVolumeError',
    defaultMessage: 'Minimum volume for aliquots is 10.',
  },
  maxNrNormalizationAliquotsVolumeError: {
    id: 'maxNrNormalizationAliquotsVolumeError',
    defaultMessage: 'Aliquots should not exceed {value}.',
  },
});

export default { ...generalMessages, ...messages };
